import { useQuery } from "@tanstack/vue-query";
import { api } from "@/api";

export const SITE_QUERY_KEY = "sites";

export type Site = {
  id: string;
  name: string;
  regionId: string;
  isTraining: boolean;
  isPitchValidation: boolean;
  isCompanion: boolean;
  isDigitalArrivals: boolean;
  isKeypad: boolean;
  isExperienceFreedom: boolean;
  hasKeysafePitch: boolean;
  hasExitCamera: boolean;
  hasStorageCompound: boolean;
  /** Where the storage compound is on the site plan; null until placed in admin. */
  storagePlanX: number | null;
  storagePlanY: number | null;
  siteMapImage: string | null;
  bulkMessageEnabled: boolean;
};

export const listSites = async () => {
  const { body } = await api.get<Site[]>("/sites");

  return body;
};

export const useSites = () => {
  return useQuery({
    queryKey: [SITE_QUERY_KEY],
    queryFn: () => listSites(),
    staleTime: 60 * 60 * 1000,
  });
};
